/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_FilesInputs */



/**
* | output |
* | --- |
* | "Media Files" |
*
* @param {Media_FilesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_files = /** @type {((inputs?: Media_FilesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_FilesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fichiers multimédia")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mediendateien")
	if (locale === "it") return /** @type {LocalizedString} */ ("File multimediali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Медиафайлы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Archivos multimedia")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("媒体文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアファイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया फ़ाइलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arquivos de mídia")
	return /** @type {LocalizedString} */ ("Media Files")
});